/** @jsxImportSource @emotion/react */

import { COLORS, getColorById } from '@btime/constants'
import { css } from '@emotion/react'
import { initials } from '@btime/helpers'
import { path } from 'ramda'
// eslint-disable-next-line
import React from 'react'

import { Text } from './Text'

const sizes = {
  xsmall: { sizeInRem: 1.2, fontSize: 'xxsmall' },
  small: { sizeInRem: 2, fontSize: 'small' },
  normal: { sizeInRem: 3, fontSize: 'h5' },
  medium: { sizeInRem: 4, fontSize: 'h4' },
  large: { sizeInRem: 6, border: 1, fontSize: 'h2' },
  xlarge: { sizeInRem: 8, border: 4, fontSize: 'h1' }
}

const Avatar = ({ size, bgContain, name, bgColor, borderColor, image, colorById, color, square }) => {
  bgColor = bgColor || color
  if (colorById) bgColor = getColorById(colorById)
  const { sizeInRem, fontSize, border } = sizes[size] || sizes.small
  const finalColor = bgColor || COLORS.purple

  const style = css`
    min-width: ${sizeInRem}rem;
    width: ${sizeInRem}rem;
    height: ${sizeInRem}rem;
    border-radius: ${square ? 0.2 : sizeInRem}rem;
    background-color: ${!image && finalColor};
    ${!!image ? `border: solid ${border || 1}px ${COLORS.light2}` : ''};
    ${!!borderColor ? `border: solid ${border || 1}px ${borderColor}` : ''};
    background-image: url(${image});
    background-repeat: no-repeat;
    background-size: ${bgContain ? 'contain' : 'cover'};
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
  `

  const label = initials(name)

  return (
    <div css={style} className="avatar">
      {!image && (
        <Text align="center" size={fontSize} color={COLORS.white} bold>
          {label}
        </Text>
      )}
    </div>
  )
}

export const UserAvatar = ({ user, ...props }) => {
  if (!user || !user.id) return false
  const image = path(['avatar', 'fileSrc'], user)
  return <Avatar name={user.name} image={image} colorById={user.id} {...props} />
}

export const CompanyAvatar = ({ company, ...props }) => {
  return <UserAvatar user={company} square bgContain {...props} />
}

export default Avatar
